import { render, staticRenderFns } from "./SoCourseActions.vue?vue&type=template&id=75202e71&"
import script from "./SoCourseActions.vue?vue&type=script&lang=js&"
export * from "./SoCourseActions.vue?vue&type=script&lang=js&"
import style0 from "./SoCourseActions.vue?vue&type=style&index=0&id=75202e71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports